import { ApplicationsListLayout } from './layouts';
import { ApplicationContextProvider } from './context';
import { LoadingPage } from '~/pages/LoadingPage';
import { ErrorPage, ErrorHandler } from '~/pages/ErrorPage';
import { useWindowDocumentTitle } from '~/lib/useWindowDocumentTitle';
import { useApplicationsPageProps } from './data/useApplicationsPageProps';
import { useSchoolCustomizations } from '~/data/useSchoolCustomizations';

export function ApplicationsPage() {
  useWindowDocumentTitle('Applications');
  const { initialProps, isLoadingInitialProps, isInitialPropsError, initialPropsError } = useApplicationsPageProps();
  const {
    schoolCustomizations,
    isLoadingSchoolCustomizations,
    isSchoolCustomizationsError,
    schoolCustomizationsError,
  } = useSchoolCustomizations();
  if (
    !isInitialPropsError &&
    !isSchoolCustomizationsError &&
    (isLoadingInitialProps || isLoadingSchoolCustomizations)
  ) {
    return <LoadingPage />;
  }
  if (isInitialPropsError || isSchoolCustomizationsError) {
    return <ErrorHandler error={initialPropsError} />;
  }
  if (isSchoolCustomizationsError) {
    return <ErrorHandler error={schoolCustomizationsError} />;
  }
  if (!initialProps || !schoolCustomizations) {
    return <ErrorPage customMessage="Failed to fetch page props." />;
  }

  return (
    <ApplicationContextProvider initialProps={initialProps} schoolCustomizations={schoolCustomizations}>
      <ApplicationsListLayout />
    </ApplicationContextProvider>
  );
}
